import {
  Modal as NextModal,
  ModalProps as _ModalProps,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@heroui/react';
import { forwardRef, ReactNode } from 'react';
import { TestIdMixin } from '../../types';

export interface ModalProps extends Omit<_ModalProps, 'children'>, TestIdMixin {
  title?: string;
  children?: ReactNode;
  footer?: ReactNode;
  showCloseButton?: boolean;
  placement?:
    | 'center'
    | 'auto'
    | 'top'
    | 'top-center'
    | 'bottom'
    | 'bottom-center';
  isDismissable?: boolean;
}

export const Modal = forwardRef<HTMLElement | null, ModalProps>(
  (
    {
      title,
      children,
      footer,
      showCloseButton = true,
      size = 'md',
      backdrop = 'opaque',
      placement,
      isDismissable,
      ...props
    },
    ref
  ) => {
    return (
      <NextModal
        ref={ref}
        size={size}
        backdrop={backdrop}
        placement={placement || 'center'}
        isDismissable={isDismissable ?? true}
        hideCloseButton={!showCloseButton}
        {...props}
      >
        <ModalContent>
          {(onClose) => (
            <>
              {title && (
                <ModalHeader className="flex flex-col gap-1 text-lg font-bold">
                  {title}
                </ModalHeader>
              )}
              <ModalBody>{children}</ModalBody>
              {footer && <ModalFooter>{footer}</ModalFooter>}
            </>
          )}
        </ModalContent>
      </NextModal>
    );
  }
);

export { useDisclosure };
